
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
@Component({
  name: 'catalog-product-family-products',
  components: {
    ...ServiceContainer().getComponents(),
  }
})

export default class extends Vue {

  @Prop({required: true}) private familyProducts: Array<object>;
  @Prop({required: true}) private parentProduct: Array<object>;
  @Prop({required: true}) private imageBaseUrl: string;

  private selectedFamilyProduct: number = 0;
  private isDropdownActive: boolean = false;

  private handleChange($event): void {
    window.location.href = this.familyProducts[this.selectedFamilyProduct]['url_key'];
  }

  private getProductImage(image): string {
    return `${this.imageBaseUrl}/cdn/resize-extended/rs:fill/w:50/h:50/extend:true/background:255:255:255/path/media/catalog/product${image}`;
  }

  private created(): void {
    this.selectedFamilyProduct = 0;
  }
}
